/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Mode_LocalInputs */



/**
* | output |
* | --- |
* | "Local (free)" |
*
* @param {Embed_Captions_Mode_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_mode_local = /** @type {((inputs?: Embed_Captions_Mode_LocalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Mode_LocalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Local (gratuit)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokal (kostenlos)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Locale (gratuito)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Местный (бесплатно)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Local (gratis)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本地（免费）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("地元住民向け（無料）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय (निःशुल्क)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local (gratuito)")
	return /** @type {LocalizedString} */ ("Local (free)")
});